import { render, staticRenderFns } from "./ComponentAddModal.vue?vue&type=template&id=579a21d2&"
import script from "./ComponentAddModal.vue?vue&type=script&lang=js&"
export * from "./ComponentAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ComponentAddModal.vue"
export default component.exports